export default __webpack_public_path__ + "static/media/BasicLayout.c7476cfd.less";